import { useMemo } from "react";
import { UnknownMessage } from "../components/UknownMessage";
import { CardMiddleware } from "./card-middleware";
import { joinMiddlewares } from "./join";
import { useLateMiddleware } from "./late-middleware";
import { ListMiddleware } from "./list-middleware";
import { MessageMiddleware, MessageMiddlewareBuilder } from "./message-middleware";
import { MultiSelectMiddleware } from "./multiselect-middleware";
import { TableMiddleware } from "./table-middleware";

export const StandardMiddlewaresBuilder = joinMiddlewares([
    ListMiddleware,
    CardMiddleware,
    MultiSelectMiddleware,
    TableMiddleware
]);

export function useStandardMiddlewareBuilder(): MessageMiddlewareBuilder {

    const lateMiddleware = useLateMiddleware();

    return useMemo<MessageMiddlewareBuilder>(() => joinMiddlewares([
        lateMiddleware,
        StandardMiddlewaresBuilder,
    ]), [lateMiddleware]);
}

export function useStandardMiddleware(): MessageMiddleware {

    const builder = useStandardMiddlewareBuilder();

    return useMemo<MessageMiddleware>(() => builder(UnknownMessage), [builder]);
}

export const StandardMiddlewares = StandardMiddlewaresBuilder(UnknownMessage);